import { render, staticRenderFns } from "./PickupContainer.vue?vue&type=template&id=84e711d6&scoped=true&"
import script from "./PickupContainer.vue?vue&type=script&lang=js&"
export * from "./PickupContainer.vue?vue&type=script&lang=js&"
import style0 from "./PickupContainer.vue?vue&type=style&index=0&id=84e711d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e711d6",
  null
  
)

export default component.exports